import { ValueOf } from 'shared/types/generic'

export const SearchParamsKeys = {
    searchQuery: 's',
} as const

export type SearchParamsKeys = ValueOf<typeof SearchParamsKeys>

export const SearchDropdownMode = {
    initial: 'initial',
    trending: 'trending',
    results: 'results'
} as const

export type SearchDropdownMode = ValueOf<typeof SearchDropdownMode>

export const SearchQuerySuggestionSource = {
    instantQuerySuggestion: 'instant_query_suggestion',
    trendingCategoryFacet: 'trending_category_facet',
    trendingShortNameFacet: 'trending_shortname_facet',
} as const

export type SearchQuerySuggestionSource = ValueOf<typeof SearchQuerySuggestionSource>

export interface SearchQuerySuggestionItem {
    value: string
    source: SearchQuerySuggestionSource
    queryID: string | null
    /**
     * 1-based position within the source query (required by Algolia Insights).
     * For interleaved lists, this MUST stay per-source, not per-UI-position.
     */
    sourcePosition: number
}
